import { render, staticRenderFns } from "./ListGame.vue?vue&type=template&id=22d2e76e&"
import script from "./ListGame.vue?vue&type=script&lang=js&"
export * from "./ListGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports